export default "__VITE_ASSET__Dw_p0zED__"